import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e1f3166")

_pushScopeId("data-v-3e1f3166")
const _hoisted_1 = { class: "vue-flex-row karte-item-header" }
const _hoisted_2 = { class: "karte-header-title" }
const _hoisted_3 = { class: "karte-parts-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_icon_button_middle = _resolveComponent("icon-button-middle")
  const _component_vue_head_button_frame = _resolveComponent("vue-head-button-frame")
  const _component_karte_parts_time_range = _resolveComponent("karte-parts-time-range")
  const _component_karte_parts_single_line = _resolveComponent("karte-parts-single-line")
  const _component_karte_parts_multi_line = _resolveComponent("karte-parts-multi-line")
  const _component_karte_parts_images = _resolveComponent("karte-parts-images")
  const _component_karte_parts_image_and_text = _resolveComponent("karte-parts-image-and-text")
  const _component_karte_parts_attach_files = _resolveComponent("karte-parts-attach-files")
  const _component_karte_parts_single_choice = _resolveComponent("karte-parts-single-choice")
  const _component_karte_parts_multi_choice = _resolveComponent("karte-parts-multi-choice")
  const _component_karte_parts_acu = _resolveComponent("karte-parts-acu")
  const _component_vue_sub_content = _resolveComponent("vue-sub-content")

  return (_openBlock(), _createBlock(_component_vue_sub_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_fa_icon, { icon: "pen" }),
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ]),
        _createVNode(_component_vue_head_button_frame, null, {
          default: _withId(() => [
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "history",
              state: "normal",
              disabled: !_ctx.karteResultControlMap[_ctx.resultId].history,
              onClick: _ctx.onHistory
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "arrow-up",
              state: "warning",
              disabled: !_ctx.karteResultControlMap[_ctx.resultId].up,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upResult(_ctx.resultId)))
            }, null, 8, ["disabled"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "arrow-down",
              state: "warning",
              disabled: !_ctx.karteResultControlMap[_ctx.resultId].down,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downResult(_ctx.resultId)))
            }, null, 8, ["disabled"]),
            _createVNode(_component_icon_button_middle, {
              class: "group-button",
              icon: "times",
              state: "delete",
              disabled: !_ctx.karteResultControlMap[_ctx.resultId].delete,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteResult(_ctx.resultId)))
            }, null, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kartePartsResult, (karteParts, j) => {
          return (_openBlock(), _createBlock(_Fragment, null, [
            (karteParts.partsName==='timeRange')
              ? (_openBlock(), _createBlock(_component_karte_parts_time_range, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='singleLine')
              ? (_openBlock(), _createBlock(_component_karte_parts_single_line, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='multiLine')
              ? (_openBlock(), _createBlock(_component_karte_parts_multi_line, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='images')
              ? (_openBlock(), _createBlock(_component_karte_parts_images, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='imageAndText')
              ? (_openBlock(), _createBlock(_component_karte_parts_image_and_text, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='attachFiles')
              ? (_openBlock(), _createBlock(_component_karte_parts_attach_files, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='singleChoice')
              ? (_openBlock(), _createBlock(_component_karte_parts_single_choice, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='multiChoice')
              ? (_openBlock(), _createBlock(_component_karte_parts_multi_choice, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true),
            (karteParts.partsName==='acu')
              ? (_openBlock(), _createBlock(_component_karte_parts_acu, {
                  key: karteParts.id,
                  resultIndex: _ctx.resultIndex,
                  kartePartsIndex: j
                }, null, 8, ["resultIndex", "kartePartsIndex"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }))
})